import type { ReactNode } from 'react'

import type { TMergePublicationTypes } from '../../../models/publication.types'
import type { TPublicationToShare } from '../PublicationShareModal'
import type { TPublicationCardBaseProps } from './PublicationCardBase'
import { PublicationCardBase } from './PublicationCardBase'
import { type TUsePublicationHandlersProps, usePublicationHandlers } from './usePublicationHandlers'

export type TPublicationCardProps = Omit<
  TPublicationCardBaseProps,
  'onCardPress' | 'onCommentPress' | 'onSharePress' | 'publication'
> &
  Omit<TUsePublicationHandlersProps, 'publication'> & {
    publication: TMergePublicationTypes<[TPublicationCardBaseProps['publication'], TPublicationToShare]>
  }

export const PublicationCard = ({
  cardClickEvent,
  publication,
  publicationTrackingSource,
  trackingSource,
  ...otherProps
}: TPublicationCardProps): ReactNode => {
  const handlers = usePublicationHandlers({
    publication,
    trackingSource,
    publicationTrackingSource,
    cardClickEvent,
  })

  return <PublicationCardBase publication={publication} {...handlers} {...otherProps} />
}
